import {
  useState,
  useCallback,
  useEffect,
} from 'react'
import {
  v4 as uuidv4,
} from 'uuid'

const useToasterContext = () => {
  const [toasts, setToasts] = useState([])

  const timeouts = []

  const showToast = useCallback(({ message = '', type = 'info', duration = 6000 } = {}) => {
    if (!message) return
    const randomUuidV4 = uuidv4()

    const newToast = {
      id: randomUuidV4,
      message,
      type,
    }

    setToasts([...toasts, newToast])

    const timeout = setTimeout(() => {
      setToasts(currentToasts => currentToasts.filter(({ id }) => id !== randomUuidV4))
    }, duration)

    timeouts.push(timeout)
  }, [toasts])

  useEffect(() => {
    return () => {
      timeouts.forEach(clearTimeout)
    }
  }, [])

  return {
    showToast,
    toasts,
  }
}

export default useToasterContext
